import { PlayerApi } from '../../communication/player-api/PlayerApi'
import {PlayerProfile} from '../../communication/PlayerApiProtocol.generated'
import {getStore, ApplicationState} from '../Store'
import {ReduxAction, hasExpired, createAction} from '../ReduxUtils'

export const REQUEST_MY_PROFILE = 'REQUEST_MY_PROFILE'
export const RECEIVE_MY_PROFILE = 'RECEIVE_MY_PROFILE'
export const TOGGLE_ACCOUNT_OVERLAY = 'TOGGLE_ACCOUNT_OVERLAY'
export const CLOSE_ACCOUNT_OVERLAY = 'CLOSE_ACCOUNT_OVERLAY'
export const MY_PROFILE_ERROR = 'MY_PROFILE_ERROR'
export const UPDATE_AVATAR_ID = 'UPDATE_AVATAR_ID'
export const REQUEST_BONUSES = 'REQUEST_BONUSES'

export const fetchPlayerProfile = (force? : boolean) => getStore().dispatch(_fetchProfile(force) as any)

function _fetchProfile(force? : boolean) {
	return (dispatch, getState : () => ApplicationState) => {
		if (!hasExpired(force,getState().player.profile, 120)) {
			return
		}
		dispatch(requestMyProfile())

		PlayerApi.requestPrivatePlayerProfile((profile : PlayerProfile) => {
			dispatch(receiveMyProfile(profile))
		},()=>{
			dispatch(myProfileError())
		})
	}
}
export function closeAccountOverlay() : ReduxAction<{}> {
	return createAction(CLOSE_ACCOUNT_OVERLAY, {})
}

export function updateAvatarId(id : string) : ReduxAction<{}> {
	return createAction(UPDATE_AVATAR_ID, id)
}
export function toggleAccountOverlay() : ReduxAction<{}> {
	return {
		type : TOGGLE_ACCOUNT_OVERLAY,
		payload : {},
		createdTime : Date.now()
	}
}
function myProfileError() : ReduxAction<{}> {
	return {
		type: MY_PROFILE_ERROR,
		payload: {},
		createdTime : Date.now()
	}
}
function requestMyProfile() : ReduxAction<{}> {
	return {
		type: REQUEST_MY_PROFILE,
		payload: {},
		createdTime : Date.now()
	}
}
function receiveMyProfile(profile : PlayerProfile) : ReduxAction<PlayerProfile> {
	return createAction(RECEIVE_MY_PROFILE, profile)
}

